import { css } from 'styled-components'

/**
 * Palette lifted verbatim from the design prototype.
 *
 * Declared as custom properties on the calendar root rather than read from
 * the styled-components theme, so that swapping onto LuxKit palette tokens if this is ever promoted to LuxKit —
 * and picking up the rebrand and dark palettes with them — is a change to
 * this one block rather than a hunt through every rule.
 */
export const calendarTokens = css`
  --lux-cal-surface: #FFFFFF;
  --lux-cal-sunken: #F7F7F6;
  --lux-cal-border: #E3E3E3;
  --lux-cal-border-strong: #C9C6C0;
  --lux-cal-text: #161719;
  --lux-cal-muted: #6E6A63;
  --lux-cal-faint: #B4B1AB;
  --lux-cal-disabled-bg: #F6F6F5;

  --lux-cal-member: #1E5FC7;
  --lux-cal-member-dark: #0B2A5B;

  --lux-cal-selected: #0F4C4C;
  --lux-cal-range-edge: #EDEDEC;
  --lux-cal-range-fill: #F7F7F6;

  --lux-cal-cheap: #0A7A3D;
  --lux-cal-limited: #B76A00;
  --lux-cal-exclusive: #D4531E;
`
